import React from 'react';

export const TrustedLocation = () => (
    <div className="trusted-location">
        <h3>Set Egnyte as a trusted place (optional)</h3>
        <p>Set Egnyte as a trusted place in MS Office to remove Protected View warnings (optional)</p>

        <button
            type="button"
            className="learn-more-btn"
            onClick={() =>
                window.open(
                    'https://helpdesk.egnyte.com/hc/en-us/articles/20341105886221-Protected-View-Message-Workaround-for-Co-Editing-with-Microsoft-Office-Desktop',
                    '_blank'
                )
            }
        >
            Learn more
        </button>
    </div>
);
